var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-container"},[(_vm.w.data && _vm.w.data.src)?_c('img',{staticStyle:{"height":"100%","width":"100%","object-fit":"contain"},attrs:{"src":_vm.w.data.src}}):_c('p',[_vm._v("No image available for display.")])])}
var staticRenderFns = []

export { render, staticRenderFns }